<template>
  <v-dialog v-model="visible" fullscreen hide-overlay transition="dialog-bottom-transition" @keydown.esc="close">
    <v-card class="dps-card">
      <div class="glass-header-eracun">
        <div class="header-pattern"></div>
        <div class="header-title">
          <v-icon color="white" class="mr-2">mdi-tag-outline</v-icon>
          <h2 class="headline-eracun white--text">{{ modalTitle }}</h2>
        </div>
        <v-btn icon class="close-btn" @click="close"><v-icon color="white">mdi-close</v-icon></v-btn>
      </div>
      <div class="dps-body">
        <div class="dps-settings">
          <v-expansion-panels v-model="openPanels" multiple flat accordion class="settings-accordion">
            <v-expansion-panel>
              <v-expansion-panel-header>Dimenzije i raspored</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense class="settings-row">
                  <v-col cols="6">
                    <v-text-field v-model.number="boxWidthMm" type="number" min="1" label="Širina kutije (mm)" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model.number="boxHeightMm" type="number" min="1" label="Visina kutije (mm)" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model.number="columns" type="number" min="1" label="Broj po redu" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                  <v-col cols="6" v-if="scope !== 'catalog'">
                    <v-text-field v-model.number="copies" type="number" min="1" label="Broj kopija po artiklu" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model.number="hGapMm" type="number" min="0" label="Horizontalni razmak (mm)" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model.number="vGapMm" type="number" min="0" label="Vertikalni razmak (mm)" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model.number="lineSpacingMm"
                      type="number"
                      min="0"
                      max="5"
                      step="0.1"
                      label="Razmak između redova (mm)"
                      outlined
                      dense
                      class="filter-select"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Margine stranice</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense class="settings-row">
                  <v-col cols="6">
                    <v-text-field v-model.number="marginTopMm" type="number" min="0" label="Gornja margina (mm)" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model.number="marginLeftMm" type="number" min="0" label="Lijeva margina (mm)" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Dizajn i fontovi</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="orientation-field">
                  <div class="orientation-label">Orijentacija</div>
                  <v-radio-group v-model="orientation" row hide-details class="mt-0">
                    <v-radio value="portrait" color="#3989C9">
                      <template v-slot:label>
                        <v-icon size="40">mdi-crop-portrait</v-icon>
                      </template>
                    </v-radio>
                    <v-radio value="landscape" color="#3989C9">
                      <template v-slot:label>
                        <v-icon size="40">mdi-crop-landscape</v-icon>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
                <v-row dense class="settings-row mt-2">
                  <v-col cols="7">
                    <v-text-field v-model.number="labelFontSize" type="number" min="1" max="25" label="Veličina fonta (labela)" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                  <v-col cols="5" class="d-flex align-center">
                    <v-checkbox v-model="labelBold" label="Bold" color="#00838F" hide-details class="bold-checkbox"></v-checkbox>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field v-model.number="valueFontSize" type="number" min="1" max="25" label="Veličina fonta (vrijednost)" outlined dense class="filter-select"></v-text-field>
                  </v-col>
                  <v-col cols="5" class="d-flex align-center">
                    <v-checkbox v-model="valueBold" label="Bold" color="#00838F" hide-details class="bold-checkbox"></v-checkbox>
                  </v-col>
                </v-row>
                <v-checkbox v-model="border" label="Obrub oko naljepnice" color="#00838F" hide-details class="mt-1"></v-checkbox>
                <v-radio-group v-if="border" v-model="borderStyle" row class="mt-2">
                  <v-radio label="Pravokutni" value="square" color="#3989C9"></v-radio>
                  <v-radio label="Zaobljen" value="rounded" color="#3989C9"></v-radio>
                </v-radio-group>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="dps-preview">
          <iframe v-if="previewBlobUrl" :src="previewBlobUrl" class="dps-iframe"></iframe>
          <div v-else class="dps-loading">
            <v-progress-circular indeterminate color="#00BCD4" size="40" />
            <span>Generiram pretpregled...</span>
          </div>
        </div>
        <div class="dps-actions">
          <button class="dps-action dps-action--primary" :disabled="!previewBlobUrl" @click="printPdf">
            <v-icon size="18" color="white" class="mr-2">mdi-printer-outline</v-icon>
            Isprintaj
          </button>
          <button class="dps-action" :disabled="!previewBlobUrl" @click="downloadPdf">
            <v-icon size="18" color="#00BCD4" class="mr-2">mdi-download-outline</v-icon>
            Preuzmi PDF
          </button>
          <div class="dps-spacer"></div>
          <button class="dps-action dps-action--close" @click="close">
            <v-icon size="18" color="#64748B" class="mr-2">mdi-close</v-icon>
            Zatvori
          </button>
        </div>
      </div>
    </v-card>
    <declaration-label-print-table
      v-if="labelEntries.length > 0"
      ref="labelTable"
      :entries="labelEntries"
      :settings="labelRenderSettings"
    ></declaration-label-print-table>
  </v-dialog>
</template>
<script>
import state from '@/state'
import { saveLabelPrintSettings } from './declarationsService.js'
import DeclarationLabelPrintTable from './DeclarationLabelPrintTable.vue'

const PREVIEW_DEBOUNCE_MS = 500

export default {
  name: 'DeclarationLabelSettingsModal',
  components: { DeclarationLabelPrintTable },
  data: () => ({
    visible: false,
    openPanels: [0],
    scope: 'catalog',
    boxWidthMm: 60,
    boxHeightMm: 40,
    columns: 3,
    hGapMm: 2,
    vGapMm: 2,
    marginTopMm: 10,
    marginLeftMm: 10,
    copies: 1,
    orientation: 'portrait',
    labelFontSize: 9,
    labelBold: true,
    valueFontSize: 9,
    valueBold: false,
    lineSpacingMm: 1,
    border: true,
    borderStyle: 'square',
    previewItem: null,
    previewFields: [],
    entries: [],
    previewBase64: null,
    previewBlobUrl: null,
    debounceTimer: null
  }),
  computed: {
    settingsPayload () {
      return {
        box_width_mm: this.boxWidthMm,
        box_height_mm: this.boxHeightMm,
        columns: Math.max(1, this.columns || 1),
        h_gap_mm: this.hGapMm,
        v_gap_mm: this.vGapMm,
        margin_top_mm: this.marginTopMm,
        margin_left_mm: this.marginLeftMm,
        orientation: this.orientation,
        label_font_size: this.labelFontSize,
        label_bold: this.labelBold,
        value_font_size: this.valueFontSize,
        value_bold: this.valueBold,
        line_spacing_mm: this.lineSpacingMm,
        border: this.border,
        border_style: this.borderStyle
      }
    },
    labelRenderSettings () {
      return this.settingsPayload
    },
    labelEntries () {
      if (this.scope === 'catalog') return this.entries
      const copies = Math.max(1, this.copies || 1)
      if (this.scope === 'single') {
        if (!this.previewItem) return []
        return new Array(copies).fill({ item: this.previewItem, fields: this.previewFields })
      }
      // scope === 'selected' - repeat each selected item `copies` times
      const repeated = []
      this.entries.forEach(entry => {
        for (let i = 0; i < copies; i++) repeated.push(entry)
      })
      return repeated
    },
    modalTitle () {
      if (this.scope === 'single') return `Naljepnice — ${this.previewItem ? this.previewItem.name : ''}`
      if (this.scope === 'selected') return 'Naljepnice — odabrani artikli'
      return 'Naljepnice — sve aktivne'
    },
    pdfFilename () {
      if (this.scope === 'single') return `Naljepnice-${this.previewItem.name}.pdf`
      return 'Naljepnice.pdf'
    }
  },
  watch: {
    boxWidthMm () { this.schedulePreview() },
    boxHeightMm () { this.schedulePreview() },
    columns () { this.schedulePreview() },
    copies () { this.schedulePreview() },
    hGapMm () { this.schedulePreview() },
    vGapMm () { this.schedulePreview() },
    marginTopMm () { this.schedulePreview() },
    marginLeftMm () { this.schedulePreview() },
    orientation () { this.schedulePreview() },
    labelFontSize () { this.schedulePreview() },
    labelBold () { this.schedulePreview() },
    valueFontSize () { this.schedulePreview() },
    valueBold () { this.schedulePreview() },
    lineSpacingMm () { this.schedulePreview() },
    border () { this.schedulePreview() },
    borderStyle () { this.schedulePreview() }
  },
  methods: {
    open (scope, savedLabelSettings, context) {
      this.scope = scope
      if (savedLabelSettings) {
        this.boxWidthMm = savedLabelSettings.box_width_mm || 60
        this.boxHeightMm = savedLabelSettings.box_height_mm || 40
        this.columns = savedLabelSettings.columns || 3
        this.hGapMm = savedLabelSettings.h_gap_mm || 2
        this.vGapMm = savedLabelSettings.v_gap_mm || 2
        this.marginTopMm = savedLabelSettings.margin_top_mm || 10
        this.marginLeftMm = savedLabelSettings.margin_left_mm || 10
        this.orientation = savedLabelSettings.orientation || 'portrait'
        this.labelFontSize = savedLabelSettings.label_font_size || 9
        this.labelBold = savedLabelSettings.label_bold !== undefined ? savedLabelSettings.label_bold : true
        this.valueFontSize = savedLabelSettings.value_font_size || 9
        this.valueBold = savedLabelSettings.value_bold !== undefined ? savedLabelSettings.value_bold : false
        this.lineSpacingMm = savedLabelSettings.line_spacing_mm !== undefined ? savedLabelSettings.line_spacing_mm : 1
        this.border = savedLabelSettings.border !== undefined ? savedLabelSettings.border : true
        this.borderStyle = savedLabelSettings.border_style || 'square'
      } else {
        this.boxWidthMm = 60
        this.boxHeightMm = 40
        this.columns = 3
        this.hGapMm = 2
        this.vGapMm = 2
        this.marginTopMm = 10
        this.marginLeftMm = 10
        this.orientation = 'portrait'
        this.labelFontSize = 9
        this.labelBold = true
        this.valueFontSize = 9
        this.valueBold = false
        this.lineSpacingMm = 1
        this.border = true
        this.borderStyle = 'square'
      }
      this.copies = 1
      if (scope === 'single') {
        this.previewItem = context.item
        this.previewFields = context.fields
        this.entries = []
      } else {
        this.previewItem = null
        this.previewFields = []
        this.entries = context.entries
      }
      this.previewBase64 = null
      this.previewBlobUrl = null
      this.visible = true
      this.regeneratePreview()
    },
    close () {
      this.visible = false
      if (this.debounceTimer) clearTimeout(this.debounceTimer)
      if (this.previewBlobUrl) { URL.revokeObjectURL(this.previewBlobUrl); this.previewBlobUrl = null }
      this.previewBase64 = null
    },
    schedulePreview () {
      if (this.debounceTimer) clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => { this.regeneratePreview() }, PREVIEW_DEBOUNCE_MS)
    },
    async regeneratePreview () {
      await this.$nextTick()
      const ref = this.$refs.labelTable
      if (!ref) return
      const base64 = await ref.generate()
      if (!this.visible) return
      this.previewBase64 = base64
      if (this.previewBlobUrl) URL.revokeObjectURL(this.previewBlobUrl)
      this.previewBlobUrl = URL.createObjectURL(this.base64ToBlob(base64))
    },
    base64ToBlob (b64) {
      const bytes = atob(b64)
      const arr = new Uint8Array(bytes.length)
      for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i)
      return new Blob([arr], { type: 'application/pdf' })
    },
    async persistSettings () {
      await saveLabelPrintSettings(state.getCurrentCompany().id, this.settingsPayload)
      this.$emit('saved', this.settingsPayload)
    },
    async printPdf () {
      await this.persistSettings()
      if (!this.previewBlobUrl) return
      const iframe = document.createElement('iframe')
      iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;opacity:0;'
      iframe.src = this.previewBlobUrl
      document.body.appendChild(iframe)
      iframe.addEventListener('load', () => {
        setTimeout(() => {
          iframe.contentWindow.print()
          setTimeout(() => document.body.removeChild(iframe), 2000)
        }, 300)
      }, { once: true })
    },
    async downloadPdf () {
      await this.persistSettings()
      if (!this.previewBase64) return
      const url = URL.createObjectURL(this.base64ToBlob(this.previewBase64))
      const a = document.createElement('a')
      a.href = url
      a.download = this.pdfFilename
      a.click()
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    }
  }
}
</script>
<style scoped>
.dps-card {
  background: #F5F7FA;
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.glass-header-eracun {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  background: linear-gradient(135deg, rgba(0, 179, 190, 0.5) 0%, rgba(57, 137, 201, 0.45) 50%, rgba(97, 84, 164, 0.5) 100%) !important;
  position: relative !important;
  flex-shrink: 0;
}
.header-pattern {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  z-index: 0;
}
.header-title {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}
.headline-eracun {
  font-size: 20px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  margin: 0 !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.close-btn {
  background: rgba(255, 255, 255, 0.15);
  position: relative;
  z-index: 1;
}
.dps-body {
  flex: 1;
  display: flex;
  overflow: hidden;
}
.dps-settings {
  width: 300px;
  flex-shrink: 0;
  background: #ffffff;
  border-right: 1px solid #E2E8F0;
  padding: 16px;
  overflow-y: auto;
}
.settings-accordion {
  background: transparent !important;
  margin: 0 -16px;
}
.settings-accordion >>> .v-expansion-panel {
  background: transparent !important;
  border-bottom: 1px solid #F1F5F9;
}
.settings-accordion >>> .v-expansion-panel:last-child {
  border-bottom: none;
}
.settings-accordion >>> .v-expansion-panel::before {
  box-shadow: none !important;
}
.settings-accordion >>> .v-expansion-panel-header {
  padding: 14px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #1F2937;
  min-height: 48px;
}
.settings-accordion >>> .v-expansion-panel-content__wrap {
  padding: 12px 16px 20px;
}
.settings-row {
  row-gap: 2px;
}
.bold-checkbox.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.dps-settings >>> .v-input {
  margin-bottom: 0;
}
.dps-settings >>> .v-text-field__details,
.dps-settings >>> .v-messages {
  min-height: 0;
}
.dps-preview {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow: hidden;
  background: #F1F5F9;
}
.dps-iframe {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.10);
}
.dps-loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #94A3B8;
  font-size: 13px;
}
.dps-actions {
  width: 240px;
  flex-shrink: 0;
  background: #ffffff;
  border-left: 1px solid #E2E8F0;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 12px;
}
.dps-spacer { flex: 1; }
.dps-action {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 11px 14px;
  border-radius: 10px;
  border: 1.5px solid #E2E8F0;
  background: #F8FAFC;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
  text-align: left;
  flex-shrink: 0;
}
.dps-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.dps-action:hover:not(:disabled) {
  border-color: #00BCD4;
  color: #00BCD4;
  background: rgba(0, 188, 212, 0.05);
}
.dps-action--primary {
  background: #00BCD4 !important;
  border-color: #00BCD4 !important;
  color: #ffffff !important;
  box-shadow: 0 2px 10px rgba(0, 188, 212, 0.30);
}
.dps-action--primary:hover:not(:disabled) {
  background: #0097A7 !important;
  border-color: #0097A7 !important;
  color: #ffffff !important;
}
.dps-action--close {
  border-color: #E2E8F0;
  background: #F8FAFC;
  color: #64748B;
}
.dps-action--close:hover {
  border-color: #94A3B8;
  color: #374151;
  background: #F1F5F9;
}
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: #B0BEC5 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}
.orientation-field {
  margin-top: 16px;
}
.orientation-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 4px;
}
</style>
